// Fetch an authenticated file into a Blob for object URLs and named downloads.
//
// Request an ArrayBuffer and wrap it, never responseType "blob": Chrome fails
// repeat XHR loads of large (~10 MB) responses requested as "blob" with
// net::ERR_FAILED after the first load in an ordinary disk-cache profile, and
// then keeps re-validating its truncated cache entry with 1-byte range requests
// (206 Partial Content). The same bytes requested as an ArrayBuffer load
// reliably every time.
export async function fetchFileBlob(client, url, config) {
  const response = await client.get(url, Object.assign({}, config, { responseType: "arraybuffer" }));
  const type = (response.headers && response.headers["content-type"]) || "application/octet-stream";
  return new Blob([response.data], { type });
}
